/**
 * Referral Cookie Management
 * Handles saving and reading affiliate referral codes from cookies
 */

const REFERRAL_COOKIE_NAME = 'lts_ref';
const REFERRAL_COOKIE_DAYS = 7;

/**
 * Save a referral code to cookies
 */
export function saveReferralCode(code: string): void {
  if (!code || typeof code !== 'string' || code.length !== 5) return;
  
  const expires = new Date();
  expires.setDate(expires.getDate() + REFERRAL_COOKIE_DAYS);
  
  document.cookie = `${REFERRAL_COOKIE_NAME}=${code.toLowerCase()}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
}

/**
 * Read the referral code from cookies
 */
export function getReferralCode(): string | null {
  const cookies = document.cookie.split(';');
  
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === REFERRAL_COOKIE_NAME) {
      return value || null;
    }
  }
  
  return null;
}

/**
 * Clear the referral code cookie
 */
export function clearReferralCode(): void {
  document.cookie = `${REFERRAL_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

/**
 * Check URL params for ref code and save to cookie
 */
export function checkAndSaveReferralFromURL(): void {
  if (typeof window === 'undefined') return;
  
  const params = new URLSearchParams(window.location.search);
  const refCode = params.get('ref');
  
  if (refCode && refCode.length === 5) {
    saveReferralCode(refCode);
  }
}
